import React, { useState, createContext } from "react";

export const LanguageContext = createContext();

export const LanguageContextProvider = ({children}) => {

    const [appLanguage, setappLanguage] = useState('en');


    const switchLanguage = () => {
        appLanguage === 'en' ? setappLanguage('fr') : setappLanguage('en');
    }

    const testContext = () => {
        alert("Context api is online");
    }

    //const testVal = "test";

    return (
        <LanguageContext.Provider
            value={{
                appLanguage,
                testContext,
                switchLanguage
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
}